export function CheckBadge() {
  return (
    <span
      aria-hidden
      className='grid size-5 shrink-0 place-items-center rounded-md border border-accent bg-accent text-white'
    >
      <svg viewBox='0 0 12 12' className='size-3'>
        <path
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M2.5 6.5l2.5 2.5 4.5-5'
        />
      </svg>
    </span>
  )
}
